<template>
  <div class="component-application-type">
    <label class="checkbox"
      v-for="(name, code) of applicationStatuses" :key="code"
    >
      <input type="checkbox" v-model="selected" :value="code">
        {{ name }}
    </label>
  </div>
</template>

<script lang="ts">
import { ApplicationStatus, applicationStatusCode } from '@/store/applications/types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ApplicationStatutsesInput extends Vue {
  @Prop() value!: applicationStatusCode[]

  private applicationStatuses = ApplicationStatus

  private get selected(): applicationStatusCode[] {
    return this.value
  }

  private set selected(applicationStatusCodes: applicationStatusCode[]) {
    this.$emit('input', applicationStatusCodes)
  }
}
</script>

<style scoped>
.component-application-type {
  display:flex;
  flex-wrap: wrap;
}
input[type="checkbox"] {
  margin-right: 8px;
}

.checkbox {
  display: block;
  width: 110px;
}
</style>
